import React from 'react';

export interface RepeaterContextProps {
  repeaterId: number;
  repeaterItemId: string;
}

const RepeaterContext = React.createContext<RepeaterContextProps>({
  repeaterId: null,
  repeaterItemId: null,
});

export default RepeaterContext;
